import React, { useState } from 'react'
// import React, { useState, useMemo, useEffect } from 'react'
import { useDispatch } from 'react-redux'
// import shortid from 'shortid'
// import classNames from 'classnames'

// import ToolTip from './tooltip'
// import Row, { Slot, LabelSlot, FieldSlot } from './row'
import { FieldSlot, Cell, BodyItem } from './row'

import Input from './input'
import styles from '../component-styles/campaign-codes-administration.module.scss'
import Button from './button'
import {
  GeneratorSelectFields,
  ValidationChecks,
} from '../api-client/api-types'
import { getItemByKeyValue, prepareInput } from '../helpers'
import { updateGeneratorParameterSelectAddOptionAsync } from '../store/actions'

export interface AddNewSelectFieldProps {
  fields: { optionName: string; optionValue: string }[]
  fieldName: string
  updateSelectFields: (item: GeneratorSelectFields) => void
  restrictDropdowns: boolean
  fieldID: string | undefined
  validation?: ValidationChecks[] | undefined | null
}

const newFieldTemplate = {
  hide: false,
  optionName: '',
  optionValue: '',
}

export default function AddNewSelectField({
  fields,
  fieldName,
  updateSelectFields,
  restrictDropdowns,
  fieldID,
  validation,
}: AddNewSelectFieldProps): React.ReactElement {
  const dispatch = useDispatch()

  const [newField, setNewField] = useState<GeneratorSelectFields>({
    ...newFieldTemplate,
  })
  const [fieldNameError, setFieldNameError] = useState(false)
  const [fieldValueError, setFieldValueError] = useState(false)

  return (
    <BodyItem className={styles.addNewField}>
      <Cell width={restrictDropdowns ? 340 : 503} className={styles.fieldCell}>
        <FieldSlot column className={styles.fieldSlot}>
          <Input
            name={`${fieldName} new optionName`}
            label={`${fieldName} new optionName`}
            placeholder="Enter another here"
            value={newField.optionName}
            onChange={(e: React.ChangeEvent<HTMLInputElement>): void => {
              const { value } = e.target as HTMLInputElement
              const found = getItemByKeyValue(fields, 'optionName', value)
              if (found !== -1) {
                setFieldNameError(true)
              } else {
                setFieldNameError(false)
              }
              const optionValue = prepareInput(value, validation)

              setNewField({
                ...newField,
                optionName: value,
                optionValue,
              })
            }}
          />
          {fieldNameError && (
            <p className={styles.footNoteError}>
              This name is already being used.
            </p>
          )}
        </FieldSlot>
      </Cell>
      <Cell width={restrictDropdowns ? 340 : 503} className={styles.fieldCell}>
        <FieldSlot column className={styles.fieldSlot}>
          <Input
            key={`${fieldName} ${newField.optionName}`}
            name={`${fieldName} new optionValue`}
            label={`${fieldName} new optionValue`}
            value={newField.optionValue}
            placeholder="Enter another value here"
            onChange={(e: React.ChangeEvent<HTMLInputElement>): void => {
              const { value } = e.target as HTMLInputElement
              const found = getItemByKeyValue(fields, 'optionValue', value)
              if (found !== -1) {
                setFieldValueError(true)
              } else {
                setFieldValueError(false)
              }

              setNewField({
                ...newField,
                optionValue: value,
              })
            }}
          />
          {fieldValueError && (
            <p className={styles.footNoteError}>
              This code is already being used.
            </p>
          )}
        </FieldSlot>
      </Cell>
      {restrictDropdowns && (
        <Cell width={340}>
          <></>
        </Cell>
      )}
      <Cell width={120}>
        <Button
          disabled={
            newField.optionName === '' || fieldNameError || fieldValueError
          }
          type="container"
          className={styles.noMargin}
          onClick={(): void => {
            updateSelectFields({ ...newField })
            setNewField({ ...newFieldTemplate })

            if (fieldID) {
              dispatch(
                updateGeneratorParameterSelectAddOptionAsync({
                  fieldID,
                  newOption: {
                    ...newField,
                  },
                }),
              )
            }
          }}
        >
          Confirm
        </Button>
      </Cell>
    </BodyItem>
  )
}
